import { ProfileUser } from '@ordermentum/ui-types';
import Driver, {
  AuthSearch,
  Entity,
  AuthToken,
  EntityResponse,
  Permission,
  User,
  EntityUser,
  Role,
  Authorization,
} from '@ordermentum/auth-driver';
import { AUTH_URL } from '@ordermentum/ui-constants';

export {
  AuthSearch,
  Entity,
  AuthToken,
  EntityResponse,
  Permission,
  User,
  EntityUser,
  Role,
};

export default class Auth {
  private static instance: Driver;

  private static auth: Authorization;

  static token: string;

  static init(token: string, profile?: ProfileUser) {
    Auth.token = token;
    Auth.instance = new Driver(AUTH_URL, null, token);
    if (profile) {
      // @ts-expect-error Profile does have everything we need to represent an auth abstraction
      // It has some extra stuff, hence the types don't match
      Auth.auth = new Authorization(profile);
    }
  }

  static getAuth(): Authorization {
    if (!Auth.auth) {
      throw new Error('Authorization not found');
    }
    return Auth.auth;
  }

  static getInstance(): Driver {
    if (!Auth.token) {
      throw new Error('Auth driver init failed, token not found');
    }
    if (!Auth.instance) {
      Auth.instance = new Driver(AUTH_URL, null, Auth.token);
    }
    return Auth.instance;
  }
}
